// extracted by mini-css-extract-plugin
export default {"root":"HsDVe","myMessage":"Gq8qm","firstInGroup":"a2lZw","lastInGroup":"vY6d9","text":"f88pP"};